import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const DocumentDetailsCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${Spacing.S16} 0;
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};
`

export const DocumentDetailsCardTitle = styled.div`
  padding: 0 ${Spacing.S16};
`
